import React, { useEffect, useState } from 'react';
import {
  HashRouter,
  Route,
  Switch,
  useParams,
  useHistory
} from 'react-router-dom';
import {
  AgentMarketplaceHomePage,
  AgentStandalonePage,
  AgentBundlePage,
  OrgAgentPage,
  MarketplaceUserProfile,
  AICommunity,
  DeveloperTools
} from '@superops/agent-marketplace';
import '@superops/agent-marketplace/dist/bundled.css';
import envConfig from '@nile/home/src/Config/env';
import {
  getAiCommunityBmKey,
  getBaseUrl,
  getRegionAndEnv
} from '@nile/components/src/Utils/helpers';
import { toast } from '@nile/components';
// import AgentMarketplaceNavbar from '@nile/components/src/Navigations/AgentMarketplaceNavbar';
// import AICommunity from '@nile/banyan/src/Components/Intergration/AI Community/AI-community';
// import DeveloperTools from '@nile/banyan/src/Components/Intergration/DeveloperTools/DeveloperTools';
// import { AccountClient } from '@nile/graphql';
// import { GET_MY_ORG_AGENTS } from '@nile/banyan/src/Graphql/Query/ai';

// Component for AI Bundle route
const AIBundleRoute = ({ dcRegion, isProdEnv }) => {
  const { id } = useParams();
  const history = useHistory();

  const postOnCommunity = () => {
    history.push('/agent/marketplace/community');
  };

  return (
    <AgentBundlePage
      bundleId={id}
      consumerApp="MARKETPLACE_WEBSITE"
      goBackFunc={() => {
        history.push('/agent/marketplace');
      }}
      dcRegion={dcRegion}
      isProdEnv={isProdEnv}
      customFunctions={{
        postOnCommunity: postOnCommunity
      }}
    />
  );
};

// Component for AI Agent route
const AIAgentRoute = ({
  userProfile,
  dcRegion,
  isProdEnv,
  setAgentSpaceUrl,
  toast
}) => {
  const { id } = useParams();
  const history = useHistory();

  const postOnCommunity = () => {
    history.push('/agent/marketplace/community');
  };

  const tryAgent = (redirectUrl: string) => {
    redirectUrl
      ? window.open(redirectUrl, '_blank')
      : alert('No redirect URL given');
  };

  return (
    <AgentStandalonePage
      key={id}
      agentId={id}
      // userId="4"
      userProfile={userProfile}
      consumerApp="MARKETPLACE_WEBSITE"
      goBackFunc={() => {
        history.push('/agent/marketplace');
      }}
      customFunctions={{
        postOnCommunity: postOnCommunity,
        tryAgent: tryAgent
      }}
      dcRegion={dcRegion}
      isProdEnv={isProdEnv}
      setAgentSpaceUrl={setAgentSpaceUrl}
      toast={toast}
    />
  );
};

// Component for User Profile route
const UserProfileRoute = ({
  userProfile,
  dcRegion,
  isProdEnv,
  setUserProfile,
  toast
}) => {
  return (
    <>
      {/* <AgentMarketplaceNavbar
        currentPage="user-profile"
        appType="Marketplace"
      /> */}
      <MarketplaceUserProfile
        consumerApp="MARKETPLACE_WEBSITE"
        userProfile={userProfile}
        dcRegion={dcRegion}
        isProdEnv={isProdEnv}
        setUserProfile={setUserProfile}
        toast={toast}
      />
    </>
  );
};

// Component for Community route
const CommunityRoute = ({ userProfile, agentSpaceUrl }) => {
  return (
    <>
      {/* <AgentMarketplaceNavbar currentPage="community" appType="Marketplace" /> */}
      <AICommunity
        consumerApp="MARKETPLACE_WEBSITE"
        userProfile={userProfile}
        agentSpaceUrl={agentSpaceUrl}
      />
    </>
  );
};

// Component for Developer Tools route
const DeveloperToolsRoute = ({ userProfile }) => {
  return (
    <>
      {/* <AgentMarketplaceNavbar
        currentPage="developer-tools"
        appType="Marketplace"
      /> */}
      <DeveloperTools
        consumerApp="MARKETPLACE_WEBSITE"
        userProfile={userProfile}
      />
    </>
  );
};

// Component for Marketplace Home route
const MarketplaceHomeRoute = ({ userProfile, dcRegion, isProdEnv, toast }) => {
  const history = useHistory();

  const postOnCommunity = () => {
    history.push('/agent/marketplace/community');
  };

  return (
    <div>
      {/* <AgentMarketplaceNavbar currentPage="marketplace" appType="Marketplace" /> */}
      <AgentMarketplaceHomePage
        consumerApp="MARKETPLACE_WEBSITE"
        wrapAppProvider
        customFunctions={{
          postOnCommunity: postOnCommunity
        }}
        userProfile={userProfile}
        dcRegion={dcRegion}
        isProdEnv={isProdEnv}
        toast={toast}
      />
    </div>
  );
};

const MarketplaceApp = () => {
  const { isProdEnv, dcRegion } = getRegionAndEnv();
  const [userProfile, setUserProfile] = useState({
    id: '',
    firstName: '',
    persona: ''
  });
  const [agentSpaceUrl, setAgentSpaceUrl] = useState('/');

  const getCookieValue = (name: string) => {
    return document.cookie
      .match(RegExp(name + '=.[^;]*'))
      ?.pop()
      ?.replace(`${name}=`, '');
  };

  //get user details
  const getUserDetails = () => {
    const token = getCookieValue('so-marketplace-csrf') || '';
    const myHeaders = new Headers();
    myHeaders.append('x-marketplace-csrf-token', token);

    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow' as RequestRedirect,
      credentials: 'include'
    };
    fetch(`${getBaseUrl()}/marketplace/api/users`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        // Prefill form data if available
        if (result) {
          setUserProfile((prev) => ({
            ...prev,
            id: result.id || '',
            firstName: result.name || '',
            persona: result.persona || ''
          }));
        }
      })
      .catch((error) => {
        console.error('Error fetching user data:', error);
      });
  };

  useEffect(() => {
    getUserDetails();
    getAiCommunityBmKey();

    //get app state params if available
    const url = window.location.href;
    const queryString = url.split('?')[1];
    const params = new URLSearchParams(queryString);
    const appState = params.get('appState');

    if (appState) {
      const decoded = decodeURIComponent(appState);
      const data = JSON.parse(decoded);
      if (data?.agentPath) {
        window.location.href = `#${data.agentPath}`;
      }
    }
  }, []);
  return (
    <HashRouter>
      {/* <div className="pt20 parent-cover position-relative z1" /> */}
      <div className="agent-marketplace h-full w-full sticky-header">
        <Switch>
          <Route
            path="/agent/marketplace/:id/:name/ai-bundle"
            render={(props) => (
              <AIBundleRoute
                {...props}
                dcRegion={dcRegion}
                isProdEnv={isProdEnv}
              />
            )}
          />
          <Route
            path="/agent/marketplace/:id/:name/ai-agent"
            render={(props) => (
              <AIAgentRoute
                {...props}
                userProfile={userProfile}
                dcRegion={dcRegion}
                isProdEnv={isProdEnv}
                setAgentSpaceUrl={setAgentSpaceUrl}
                toast={toast}
              />
            )}
          />
          <Route
            path="/agent/marketplace/user-profile"
            render={(props) => (
              <UserProfileRoute
                {...props}
                userProfile={userProfile}
                dcRegion={dcRegion}
                isProdEnv={isProdEnv}
                setUserProfile={setUserProfile}
                toast={toast}
              />
            )}
          />
          <Route
            path="/agent/marketplace/community"
            render={(props) => (
              <CommunityRoute
                {...props}
                userProfile={userProfile}
                agentSpaceUrl={agentSpaceUrl}
              />
            )}
          />
          <Route
            path="/agent/marketplace/developer-tools"
            render={(props) => (
              <DeveloperToolsRoute {...props} userProfile={userProfile} />
            )}
          />
          <Route
            path={['*', '/agent/marketplace']}
            exact
            render={(props) => (
              <MarketplaceHomeRoute
                {...props}
                userProfile={userProfile}
                dcRegion={dcRegion}
                isProdEnv={isProdEnv}
                toast={toast}
              />
            )}
          />
        </Switch>
      </div>
    </HashRouter>
  );
};

export default MarketplaceApp;
